<template>
  <a-card class="auto-height">
    <!-- 公司总授权信息与Tabs在同一行 -->
    <div class="header-with-tabs">
      <a-tabs :defaultActiveKey="activeTab" type="card" @change="handleTabChange" class="inline-tabs">
        <a-tab-pane key="company" :tab="userInfo.corpName || '公司信息'" />
        <a-tab-pane key="statistics" tab="数据统计" />
      </a-tabs>
      <div class="company-info">
        <div class="authorization-info">
          <span>账号总授权 <strong>{{ userDetail.max || 0 }}</strong> | 已授权 <strong>{{ userDetail.authorizedCnt || 0 }}</strong> | 剩余授权 <strong>{{ userDetail.max - userDetail.authorizedCnt || 0 }}</strong></span>
        </div>
      </div>

      <div></div>
    </div>

    <!-- Tab内容区域 -->
    <div class="tab-content">
      <div v-if="activeTab === 'company'">
        <a-row :gutter="20">
          <!-- 左边项目管理列表 -->
          <a-col
            :xxl="5"
            :xl="6"
            :lg="6"
            :md="7"
            :sm="7"
            class="first-col">
            <a-row :gutter="8">
              <a-col :lg="20" :md="24">
                <a-input-search style="margin-bottom: 1rem" placeholder="项目名称搜索" @change="onChange"/>
              </a-col>
              <a-col :lg="4" :md="24">
                <a-button type="primary" icon="plus" @click="handleAddProject()"/>
              </a-col>
            </a-row>
            <a-list
              itemLayout="horizontal"
              :loading="loading"
              :dataSource="filteredProjects"
              style="max-height: 80vh; overflow-y: auto;">
              <a-list-item slot="renderItem" slot-scope="item" class="project-item-list" @click="(e) => handleProjectClick(e, item)">
                <a-icon slot="actions" type="edit" class="action" @click="handleEditProject(item)"/>
                <!-- <a-icon slot="actions" type="delete" class="action" @click="handleRemoveProject(item)"/> -->
                <a-list-item-meta>
                  <LauncherSvg slot="avatar" class="avatar"/>
                  <div slot="title">{{ item.name }}</div>
                  <!--  <div slot="description" class="desc">
                    <div>地址：<ellipsis :length="17" tooltip>{{ item.address || '无' }}</ellipsis></div>
                  </div> -->
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </a-col>

          <!-- 右边内容区域 -->
          <a-col
            v-if="!selectedProject"
            :xxl="19"
            :xl="18"
            :lg="18"
            :md="17"
            :sm="17">
            <div class="center blank">
              <div class="blank-intro">暂无内容</div>
            </div>
          </a-col>

          <a-col
            v-else
            :xxl="19"
            :xl="18"
            :lg="18"
            :md="17"
            :sm="17">
            <div class="account-management">

              <a-tabs v-if="!showTerminal" default-active-key="project" v-model="subActiveTab" @change="handleSubTabChange">
                <!-- 项目管理 tab -->

                <a-tab-pane key="project" tab="项目管理">
                  <div class="account-header">
                    <div class="project-info">
                      <div>项目总授权 <strong>{{ firstProjectDetail.max || 0 }}</strong> | 已授权 <strong>{{ firstProjectDetail.authorizedCnt || 0 }}</strong> | 已激活 <strong>{{ firstProjectDetail.activeCnt || 0 }}</strong></div>
                      <div class="project-actions">
                        <a-input-search placeholder="搜索" style="width: 200px; margin-right: 10px;" @change="(e) => loadSubProjects(selectedProject.id,e.target.value)"/>
                        <a-button type="primary" icon="plus" @click="handleAddSubProject">二级项目</a-button>
                      </div>
                    </div>

                    <a-table
                      :loading="tableLoading"
                      :columns="subProjectColumns"
                      :rowKey="record => record.id"
                      :dataSource="subProjectList.content || []"
                      style="width: 100%"
                      :pagination="{
                        current: pagination.current,
                        pageSize: pagination.pageSize,
                        total: subProjectList.totalElements || 0,
                        showSizeChanger: true,
                        pageSizeOptions: ['10', '20', '50', '100'],
                        onChange: handleSubProjectTablePaginationChange,
                        onShowSizeChange: handleSubProjectTablePaginationChange
                      }">
                      <span slot="action" slot-scope="record">
                        <a @click="handleEditSubProject(record)">编辑</a>
                        <a-divider type="vertical"/>
                        <a @click="handleClientSubProject(record)">终端</a>
                        <a-divider type="vertical"/>
                        <a style="color: red" @click="handleRemoveSubProject(record)">删除</a>
                      </span>
                    </a-table>
                  </div>
                </a-tab-pane>

                <!-- 配置管理 tab -->
                <a-tab-pane key="config" tab="配置管理">
                  <div v-if="showConfigList" class="config-management">
                    <div class="config-header">
                      <div class="config-title">配置列表</div>
                      <a-button type="primary" icon="plus" @click="handleAddConfig">新建配置</a-button>
                    </div>
                    <a-table
                      :loading="configLoading"
                      :columns="configColumns"
                      :rowKey="record => record.id"
                      :dataSource="configList.content || []"
                      :pagination="{
                        current: pagination.current,
                        pageSize: pagination.pageSize,
                        total: configList.totalElements || 0,
                        showSizeChanger: true,
                        pageSizeOptions: ['10', '20', '50', '100'],
                        onChange: handleConfigTablePaginationChange,
                        onShowSizeChange: handleConfigTablePaginationChange
                      }">
                      <span slot="actionConfig" slot-scope="record">
                        <a @click="handleDetailConfig(record)">详情</a>
                        <a-divider type="vertical"/>
                        <a @click="handleEditConfig(record)">编辑</a>
                        <a-divider type="vertical"/>
                        <a style="color: red" @click="handleRemoveConfig(record)">删除</a>
                      </span>
                    </a-table>
                  </div>
                  <ConfigDetail
                    v-else
                    :visible="visible.configDetail"
                    :configId="currentConfigId"
                    @close="handleCloseDetail"
                    @edit="handleEditConfig"
                  />
                </a-tab-pane>

                <!-- 资源管理 tab -->
                <a-tab-pane key="resource" tab="资源管理">
                  <div class="resource-management">
                    <div class="resource-header">
                      <div class="resource-title">应用列表</div>
                      <a-button type="primary" icon="plus" @click="handleAddApp">应用</a-button>
                    </div>
                    <a-table
                      :loading="appLoading"
                      :columns="appColumns"
                      :rowKey="record => record.md5"
                      :dataSource="appList.content || []"
                      :pagination="{
                        current: pagination.current,
                        pageSize: pagination.pageSize,
                        total: appList.totalElements || 0,
                        showSizeChanger: true,
                        pageSizeOptions: ['10', '20', '50', '100'],
                        onChange: handleAppTablePaginationChange,
                        onShowSizeChange: handleAppTablePaginationChange
                      }">
                      <span slot="icon" slot-scope="record">
                        <img v-if="record.icon && record.icon.downloadUrl" :src="record.icon.downloadUrl" alt="应用图标" style="width: 40px; height: 40px; object-fit: cover; cursor: pointer;" @click="handlePreviewIcon(record.icon.downloadUrl)"/>
                        <div v-else class="no-icon">暂无图标</div>
                      </span>
                      <span slot="actionApp" slot-scope="record">
                        <a style="color: red" @click="handleRemoveApp(record)">删除</a>
                        <a-divider type="vertical"/>
                        <a @click="handleEditApp(record)">编辑</a>
                      </span>
                    </a-table>
                  </div>
                </a-tab-pane>
              </a-tabs>
              <TerminalManagement
                v-if="showTerminal"
                :code="terminalCode"
                :subProjectName="terminalSubProjectName"
                @back="handleBackFromTerminal"
              />
            </div>
          </a-col>
        </a-row>
      </div>
      <div v-if="activeTab === 'statistics'">
        <DataStatistics :type="2" />
      </div>
    </div>

    <!-- 新建/编辑项目模态框 -->
    <ProjectModal :visible.sync="visible.projectModal" ref="projectModal" @ok="handleProjectOK" @cancel="visible.projectModal = false"/>
    <!-- 新建/编辑二级项目模态框 -->
    <SubProjectModal
      :visible.sync="visible.subProjectModal"
      :firstId="firstId"
      ref="subProjectModal"
      @ok="handleSubProjectOK"
      @cancel="visible.subProjectModal = false"
      @goToConfigManage="handleGoToConfigManage"/>
    <!-- 上传应用模态框 -->
    <AppModal :visible.sync="visible.appModal" ref="appModal" @ok="handleAppOK" @cancel="visible.appModal = false"/>
    <!-- 配置管理模态框 -->
    <ConfigModal :visible.sync="visible.configModal" ref="configModal" @ok="handleConfigOK" @cancel="visible.configModal = false" @goToResourceManage="handleGoToResourceManage"/>
    <!-- 图标预览弹窗 -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false" width="600px" centered>
      <img :src="previewImage" style="width: 100%" alt="预览"/>
    </a-modal>
  </a-card>
</template>

<script>
import { mixinDevice } from '@/utils/mixin'
import { Ellipsis } from '@/components'
import { mapGetters } from 'vuex'
import LauncherSvg from '@/assets/launcher.svg?inline'
import DataStatistics from './components/DataStatistics.vue'
import ProjectModal from './modal/projectModal.vue'
import SubProjectModal from './modal/SubProjectModal.vue'
import AppModal from './modal/appModal.vue'
import ConfigModal from './modal/ConfigModal.vue'
import ConfigDetail from './components/configDetail.vue'
import TerminalManagement from './components/TerminalManagement.vue'
import { deleteProjectSecondItem, getProjectFirstItemDetail, getProjectFirstItemPage, getProjectSecondItemDetail, getProjectSecondItemPage } from '@/api/projectItem'
import { deleteApplication, deleteConfigManage, getApplicationPage, getConfigManageDetail, getConfigManagePage } from '@/api/configManage'
import { getAreaName } from '@/utils/area'
import { getCompanyUserDetail } from '@/api/company'

export default {
  components: {
    Ellipsis,
    LauncherSvg,
    DataStatistics,
    ProjectModal,
    SubProjectModal,
    AppModal,
    ConfigModal,
    ConfigDetail,
    TerminalManagement
  },
  mixins: [mixinDevice],
  data: function () {
    return {
      activeTab: 'company',
      subActiveTab: 'project',
      loading: false,
      tableLoading: false,
      visible: {
        projectModal: false,
        subProjectModal: false,
        appModal: false,
        configModal: false,
        configDetail: false
      },
      showTerminal: false,
      terminalCode: '',
      terminalSubProjectName: '',
      previewVisible: false,
      previewImage: '',
      firstProjectDetail: {},
      showConfigList: true,
      currentConfigId: '',
      configList: [],
      configLoading: false,
      keyword: '',
      selectedProject: null,
      selectedProjectElement: null,
      projects: [],
      subProjectList: [],
      userDetail: {},
      firstId: '',
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      subProjectColumns: [{
        title: '二级项目名称',
        dataIndex: 'name',
        width: 120
      }, {
        title: '地址',
        dataIndex: 'province',
        width: 120,
        customRender: (text, record) => {
          return getAreaName(record.province)
        }
      }, {
        title: '关联配置',
        dataIndex: 'configId',
        width: 120,
        customRender: (text, record) => {
          const config = this.configList.content.find(item => item.id === record.configId)
          return config ? config.name : '无'
        }
      }, {
        title: '激活码',
        dataIndex: 'code',
        width: 100
      }, {
        title: '已激活数量',
        dataIndex: 'activeCnt',
        width: 100
      }, {
        title: '授权数量',
        dataIndex: 'max',
        width: 100
      }, {
        title: '操作',
        width: 150,
        fixed: 'right',
        scopedSlots: { customRender: 'action' }
      }],
      appList: [],
      appLoading: false,
      appColumns: [{
        title: '应用名称',
        dataIndex: 'name',
        width: 150
      }, {
        title: '应用图标',
        width: 100,
        scopedSlots: { customRender: 'icon' }
      }, {
        title: '包名',
        dataIndex: 'packageName',
        width: 150
      }, {
        title: '操作',
        width: 120,
        fixed: 'right',
        scopedSlots: { customRender: 'actionApp' }
      }],
      configColumns: [{
        title: '配置名称',
        dataIndex: 'name',
        width: 150
      }, {
        title: '菜单配置',
        dataIndex: 'menuConfigType',
        width: 100,
        customRender: (text, record) => {
          return record.menuConfigType === '0' ? '本地上传' : '云端配置'
        }
      }, {
        title: '创建时间',
        dataIndex: 'gmtCreate',
        width: 100
      }, {
        title: '操作',
        width: 100,
        scopedSlots: { customRender: 'actionConfig' }
      }]
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    filteredProjects () {
      if (this.keyword) {
        return this.projects.filter(p => p.name.indexOf(this.keyword) > -1)
      } else {
        return this.projects
      }
    }
  },
  mounted () {
    this.loadProjectData()
    this.loadConfigList()
    this.loadCompanyUserDetail()
  },
  methods: {
    loadCompanyUserDetail () {
      getCompanyUserDetail(this.userInfo.id).then(res => {
        if (res.code === 1) {
          this.userDetail = res.data || {}
          console.log(this.userDetail, res)
        }
      }).finally(() => {
        this.tableLoading = false
      })
    },
    loadProjectData () {
      this.loading = true
      const params = {
        pageNumber: 1,
        pageSize: 100
      }
      getProjectFirstItemPage(params).then(res => {
        if (res.code === 1) {
          this.projects = res.data || []
          console.log(this.projects, res)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    loadConfigList () {
      getConfigManagePage({ pageNumber: this.pagination.current, pageSize: this.pagination.pageSize }).then(res => {
        if (res.code === 1 && res.data && res.data.content) {
          this.configList = res.data || []
          this.pagination.total = res.data.totalElements || 0
          console.log(this.configList, res)
        } else {
          this.configList = []
        }
      }).catch(() => {
        this.configList = []
      })
    },

    // 预览图标
    handlePreviewIcon (url) {
      this.previewImage = url
      this.previewVisible = true
    },

    // 顶部 tab 切换
    handleTabChange (key) {
      this.activeTab = key
    },

    // 右边子 tab 切换
    handleSubTabChange (key) {
      this.subActiveTab = key
      this.pagination.current = 1
      this.pagination.pageSize = 10
      // 根据当前 tab 重新加载数据
      if (this.selectedProject) {
        this.$nextTick(() => {
          if (key === 'config') {
            this.loadConfigList()
          } else if (key === 'resource') {
            this.loadAppList(this.selectedProject.id)
          } else if (key === 'project') {
            this.loadSubProjects(this.selectedProject.id)
          }
        })
      }
    },

    // 搜索项目
    onChange (e) {
      const value = e.target.value
      if (value) {
        this.keyword = value.trim()
        if (this.keyword && this.selectedProjectElement) {
          this.selectedProjectElement.classList.remove('project-item-active')
          this.selectedProject = null
          this.selectedProjectElement = null
        }
      } else {
        this.keyword = ''
      }
    },

    // 选择项目
    handleProjectClick (e, project) {
      this.firstId = project.id
      this.selectedProject = project
      if (this.selectedProjectElement && this.selectedProjectElement !== e.currentTarget) {
        this.selectedProjectElement.classList.remove('project-item-active')
      }
      e.currentTarget.classList.add('project-item-active')
      this.selectedProjectElement = e.currentTarget
      // 加载二级项目数据
      this.loadSubProjects(project.id)
      // 加载应用数据
      this.loadAppList(project.id)
      // 获取一级项目详情
      getProjectFirstItemDetail(project.id).then(res => {
        if (res.code === 1) {
          this.firstProjectDetail = res.data || {}
        }
      }).finally(() => {
        this.tableLoading = false
      })
    },

    // 加载二级项目数据
    loadSubProjects (projectId, keyword = '') {
      this.tableLoading = true
      getProjectSecondItemPage({
        firstId: projectId,
        pageNumber: this.pagination.current,
        pageSize: this.pagination.pageSize,
        keyword: keyword
      }).then(res => {
        if (res.code === 1) {
          this.subProjectList = res.data || []
          this.tableLoading = false
        }
      }).finally(() => {
        this.tableLoading = false
      })
    },
    loadAppList (projectId) {
      this.appLoading = true
      getApplicationPage({
        pageNumber: this.pagination.current,
        pageSize: this.pagination.pageSize
      }).then(res => {
        if (res.code === 1) {
          this.appList = res.data || []
          this.appLoading = false
        }
      }).finally(() => {
        this.appLoading = false
      })
    },
    handleAppTablePaginationChange (current, pageSize, filters, sorter) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.loadAppList()
    },
    handleSubProjectTablePaginationChange (current, pageSize, filters, sorter) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.loadSubProjects(this.selectedProject.id, this.keyword)
    },

    // 新建项目
    handleAddProject () {
      this.visible.projectModal = true
    },

    // 编辑项目
    handleEditProject (project) {
      this.visible.projectModal = true
      this.$nextTick(() => this.$refs.projectModal.load(project))
    },

    // 删除项目
    handleRemoveProject (project) {
      const _this = this
      let seconds = 5
      const modal = this.$confirm({
        title: '提示',
        content: (
          <div>
              确定要删除项目<span style="font-weight: 600"> { project.name } </span>吗？
          </div>
        ),
        okType: 'danger',
        okText: `等待 ${seconds} 秒`,
        okButtonProps: { props: { disabled: true } },
        onOk () {
          modal.update({ okButtonProps: { props: { loading: true } } })
          // 模拟删除操作
          setTimeout(() => {
            _this.$message.success('删除成功')
            _this.projects = _this.projects.filter(p => p.id !== project.id)
            if (_this.selectedProject && _this.selectedProject.id === project.id) {
              _this.selectedProject = null
              _this.selectedProjectElement = null
            }
            modal.destroy()
          }, 500)
        }
      })
      const interval = setInterval(() => {
        seconds -= 1
        modal.update({
          okText: `等待 ${seconds} 秒`
        })
      }, 1000)
      setTimeout(() => {
        clearInterval(interval)
        modal.update({
          okText: '删除',
          okButtonProps: { props: { disabled: false } }
        })
      }, seconds * 1000)
    },

    // 新建二级项目
    handleAddSubProject () {
      this.visible.subProjectModal = true
    },

    // 编辑二级项目
    handleEditSubProject (subProject) {
      this.visible.subProjectModal = true
      getProjectSecondItemDetail(subProject.id).then(res => {
        if (res.code === 1) {
          this.$nextTick(() => this.$refs.subProjectModal.load(res.data))
        }
      })
    },

    // 终端管理
    handleClientSubProject (record) {
      this.terminalCode = record.code
      this.terminalSubProjectName = record.name
      this.showTerminal = true
    },
    handleBackFromTerminal () {
      this.showTerminal = false
      this.terminalCode = ''
      this.terminalSubProjectName = ''
    },

    // 删除二级项目
    handleRemoveSubProject (subProject) {
      const _this = this
      let seconds = 5
      const modal = this.$confirm({
        title: '提示',
        content: (
          <div>
              确定要删除二级项目<span style="font-weight: 600"> { subProject.name } </span>吗？
          </div>
        ),
        okType: 'danger',
        okText: `等待 ${seconds} 秒`,
        okButtonProps: { props: { disabled: true } },
        onOk () {
          modal.update({ okButtonProps: { props: { loading: true } } })
          // 模拟删除操作
          deleteProjectSecondItem(subProject.id).then(res => {
            if (res.code === 1) {
              _this.$message.success('删除成功')
              _this.loadSubProjects(_this.selectedProject.id)
              modal.destroy()
            } else {
              _this.$message.error(res.msg || '删除二级项目失败')
            }
          }).catch(() => {
            _this.$message.error('删除二级项目失败')
          })
        }
      })
      const interval = setInterval(() => {
        seconds -= 1
        modal.update({
          okText: `等待 ${seconds} 秒`
        })
      }, 1000)
      setTimeout(() => {
        clearInterval(interval)
        modal.update({
          okText: '删除',
          okButtonProps: { props: { disabled: false } }
        })
      }, seconds * 1000)
    },

    // 项目模态框确认
    handleProjectOK (project) {
      for (let i = 0; i < this.projects.length; i++) {
        if (this.projects[i].id === project.id) {
          const e = this.projects[i]
          e.name = project.name
          e.address = project.address
          e.grantCount = project.grantCount
          break
        }
      }
      this.loadProjectData()
      this.$message.success('操作成功')
    },

    // 二级项目模态框确认
    handleSubProjectOK () {
      this.loadSubProjects(this.selectedProject.id)
    },

    // 打开上传应用弹窗
    handleAddApp () {
      this.$nextTick(() => {
        if (this.$refs.appModal) {
          this.$refs.appModal.clear()
        }
      })
      this.visible.appModal = true
    },

    // 打开编辑应用弹窗
    handleEditApp (record) {
      this.visible.appModal = true
      this.$nextTick(() => {
        if (this.$refs.appModal) {
          this.$refs.appModal.load(record)
        }
      })
    },

    // 删除应用
    handleRemoveApp (app) {
      const _this = this
      let seconds = 5
      const modal = this.$confirm({
        title: '提示',
        content: (
          <div>
              确定要删除应用<span style="font-weight: 600"> { app.name } </span>吗？
          </div>
        ),
        okType: 'danger',
        okText: `等待 ${seconds} 秒`,
        okButtonProps: { props: { disabled: true } },
        onOk () {
          modal.update({ okButtonProps: { props: { loading: true } } })
          // 模拟删除操作
          deleteApplication(app.id).then(res => {
            if (res.code === 1) {
              _this.$message.success('删除成功')
              _this.loadAppList()
              modal.destroy()
            } else {
              _this.$message.error(res.msg || '删除应用失败')
            }
          }).catch(() => {
            _this.$message.error('删除应用失败')
          })
        }
      })
      const interval = setInterval(() => {
        seconds -= 1
        modal.update({
          okText: `等待 ${seconds} 秒`
        })
      }, 1000)
      setTimeout(() => {
        clearInterval(interval)
        modal.update({
          okText: '删除',
          okButtonProps: { props: { disabled: false } }
        })
      }, seconds * 1000)
    },

    // 应用模态框确认
    handleAppOK (app) {
      this.loadAppList()
    },

    // 跳转到配置管理
    handleGoToConfigManage () {
      this.visible.subProjectModal = false
      console.log(this.selectedProject, this.subActiveTab)
      this.subActiveTab = 'config'
    },

    // 新建配置
    handleAddConfig () {
      this.visible.configModal = true
    },

    // 详情配置
    handleDetailConfig (config) {
      this.currentConfigId = config.id
      this.showConfigList = false
      this.visible.configDetail = true
    },
    // 关闭详情
    handleCloseDetail () {
      this.showConfigList = true
      this.visible.configDetail = false
      this.currentConfigId = ''
    },
    handleEditConfig (config) {
      this.visible.configModal = true
      getConfigManageDetail(config.id).then(res => {
        if (res.code === 1) {
          this.$nextTick(() => this.$refs.configModal.load(res.data))
        }
      })
    },

    // 删除配置
    handleRemoveConfig (config) {
      const _this = this
      let seconds = 5
      const modal = this.$confirm({
        title: '提示',
        content: (
          <div>
              确定要删除配置<span style="font-weight: 600"> { config.name } </span>吗？
          </div>
        ),
        okType: 'danger',
        okText: `等待 ${seconds} 秒`,
        okButtonProps: { props: { disabled: true } },
        onOk () {
          modal.update({ okButtonProps: { props: { loading: true } } })
          deleteConfigManage(config.id).then(res => {
            if (res.code === 1) {
              _this.$message.success('删除成功')
              _this.loadConfigList()
              modal.destroy()
            } else {
              _this.$message.error(res.msg || '删除配置失败')
            }
          }).catch(() => {
            _this.$message.error('删除配置失败')
          })
        }
      })
      const interval = setInterval(() => {
        seconds -= 1
        modal.update({
          okText: `等待 ${seconds} 秒`
        })
      }, 1000)
      setTimeout(() => {
        clearInterval(interval)
        modal.update({
          okText: '删除',
          okButtonProps: { props: { disabled: false } }
        })
      }, seconds * 1000)
    },

    // 配置列表分页变化
    handleConfigTablePaginationChange (current, pageSize, filters, sorter) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.loadConfigList()
    },

    // 配置模态框确认
    handleConfigOK (config) {
      // 模拟保存配置
      setTimeout(() => {
        this.$message.success('操作成功')
        this.loadConfigList()
      }, 500)
    },

    // 跳转到资源管理
    handleGoToResourceManage () {
      this.visible.configModal = false
      this.subActiveTab = 'resource'
    }
  }
}
</script>

<style lang="less" scoped>
  .header-with-tabs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f0f2f5;
    border-bottom: 1px solid #e8e8e8;
    padding: 0 12px;

    .company-info {
      display: flex;
      align-items: center;
      gap: 24px;
      padding: 12px 0;

      .company-name {
        font-weight: bold;
        font-size: 16px;
      }

      .authorization-info {
        font-size: 14px;
      }
    }

    .inline-tabs {
      /deep/ .ant-tabs-bar {
        margin-bottom: 0;
        border-bottom: none;
      }
      /deep/ .ant-tabs-nav-container {
        margin-bottom: 0;
      }
    }
  }

  .tab-content {
    padding-top: 16px;
  }

  .first-col {
    margin-bottom: 2vh;

    &:after {
      position: absolute;
      top: 0.1em;
      right: 0;
      width: 0;
      height: calc(100% - 0.2em);
      content: '';
      border-right: 1px solid #e8e8e8;
    }
  }

  .project-item-list {
    &:hover {
      cursor: pointer;
      border: 1px solid #7dc6ff;
      background-color: #d2ecff;
    }

    /deep/ .ant-list-item-meta-avatar {
      margin: auto 15px auto 10px;
    }

    .avatar {
      width: 40px;
      height: 40px;
    }

    .action:hover {
      color: #1890ff;
    }

    .desc {
      font-size: 13px;
    }
  }

  .project-item-active {
    border: 1px solid #7dc6ff;
    background-color: #d2ecff;
  }

  .blank {
    margin-top: 100px;
    text-align: center;

    &-intro {
      margin: 2vh auto;
      font-size: 16px;
    }

    &-tip {
      margin: 2vh auto;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.45);
    }
  }

  .account-management {
    .account-header {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      .project-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        font-size: 14px;
        width: 98%;
        margin-bottom: 12px;
      }
      .project-actions {
        display: flex;
        align-items: center;
      }
    }
  }

  .resource-management {
    .resource-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      padding-bottom: 12px;
      border-bottom: 1px solid #e8e8e8;

      .resource-title {
        font-size: 16px;
        font-weight: bold;
      }
    }

    .no-icon {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #f0f0f0;
      border-radius: 4px;
      font-size: 12px;
      color: #999;
    }
  }

  .config-management {
    overflow-x: auto;

    .config-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      padding-bottom: 12px;
      border-bottom: 1px solid #e8e8e8;

      .config-title {
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
</style>
